export default __webpack_public_path__ + "static/media/โปรที่6BT86.e7bd34e2.png";